import { useNavigate } from "react-router-dom"
import { Action, BooleanField, Modal, ModalId, useUIActions } from "../../../../../features/ui"
import { useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { Budget, HoardType } from "../../../state/types"
import { usePriceOutlineHooks } from "../../../../operations"
import { TableName } from "../../../../../tables"

export const CreateOperationFromBudgetModal = () => {
    const navigate = useNavigate()

    const { closeModal } = useUIActions()
    const { dataType } = useRoutesHooks().parseUrl()
    const budget = dataType as Budget
    const { getPriceOutline } = usePriceOutlineHooks()

    const [keepPrices, setKeepPrices] = useState(true)

    const navigateToOperation = (path: RoutePath) => {
        closeModal(ModalId.CREATE_OPERATION_FROM_BUDGET)
        navigate(path, { state: { keepPrices } })
    }

    const onCreateFinancialHoard = () => {
        const payedAmount = getPriceOutline(TableName.BUDGETS, budget).total
        closeModal(ModalId.CREATE_OPERATION_FROM_BUDGET)
        navigate(RoutePath.CREATE_HOARD, { state: { type: HoardType.FINANCIAL, payedAmount } })
    }

    const actions: Action[] = useMemo(() => [
        { label: 'Venta', onClick: () => navigateToOperation(RoutePath.CREATE_SALE) },
        { label: 'Acopio de Productos', onClick: () => navigateToOperation(RoutePath.CREATE_HOARD) },
        { label: 'Acopio Financiero', onClick: onCreateFinancialHoard }
    ], [keepPrices])

    return (
        <Modal
            modalId={ModalId.CREATE_OPERATION_FROM_BUDGET}
            title="Crear Venta o Acopio"
            widthSize="s"
            actions={actions}
        >
            <p>¿Qué desea crear a partir de este presupuesto?</p>
            <BooleanField
                id="keep-budget-prices"
                label="Mantener precios del presupuesto original"
                value={keepPrices}
                optional
                onChange={value => setKeepPrices(!!value)}
            />
        </Modal>
    )
}
